import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";

// custom style
import { WrapperTypeObjectTitle } from "../../AccordionStyles";

//redux
import {
  setShowDataObjects,
  setFilterObject,
  showMarkerseByTypeObject,
  showMarkerseByTypeElement,
} from "redux/actions/admin";
import { useDispatch, useSelector } from "react-redux";

//helpers
import deleteDuplicatePointsLibrary from "helpers/filters/deleteDuplicatePointsLibrary";
import getLibrariesTrue from "helpers/filters/getLibrariesTrue";

//utils
import {
  PRIMARY_COLOR,
  SET_VISIBILITY_ICON,
  VISIBILITY_OFF_ICON,
} from "utils/const";

const FilterObjects = () => {
  const dispatch = useDispatch();

  const showTypeElement = useSelector(
    (state) => state.adminReducer.markerByTypeElement
  );

  const showLibrary = useSelector(
    (state) => state.adminReducer.markerByTypeObject
  );
  const showDataObjects = useSelector(
    (state) => state.adminReducer.showDataObjects
  );

  const handlerClickFilterObjects = (state, color) => {
    showTypeElement.map((elm) => {
      elm.state = state;
    });

    const dataLibraryObject = showLibrary.map((elm) => ({
      ...elm,
      state: state,
      color: color,
    }));

    dispatch(showMarkerseByTypeElement(showTypeElement));
    dispatch(showMarkerseByTypeObject(dataLibraryObject));
    dispatch(setShowDataObjects({ state: state, color: color }));
    dispatch(setFilterObject(true));
  };

  const handlerClickFilterComponentsByLibrary = (state, libraryId, color) => {
    const dataLibraryObject = showLibrary.map((elm) => {
      if (elm.libraryId === libraryId) {
        return { ...elm, state: state, color: color };
      } else {
        return elm;
      }
    });

    showTypeElement.map((elm) => {
      if (elm.libraryId === libraryId) {
        elm.state = state;
      }
    });

    const objectLibraryOff = dataLibraryObject.filter((elm) => {
      return elm.state === true;
    });

    if (showDataObjects.state === false) {
      dispatch(
        setShowDataObjects({ state: state, color: `${SET_VISIBILITY_ICON}` })
      );
    }
    if (objectLibraryOff.length === 0) {
      dispatch(
        setShowDataObjects({ state: false, color: `${VISIBILITY_OFF_ICON}` })
      );
    }
    if (objectLibraryOff.length > 0) {
      dispatch(
        setShowDataObjects({ state: true, color: `${SET_VISIBILITY_ICON}` })
      );
    }
    if (objectLibraryOff.length === dataLibraryObject.length) {
      dispatch(setShowDataObjects({ state: true, color: `${PRIMARY_COLOR}` }));
    }
    dispatch(showMarkerseByTypeElement(showTypeElement));
    dispatch(showMarkerseByTypeObject(dataLibraryObject));
    dispatch(setFilterObject(true));
  };

  const handlerClickFilterComponentsByType = (typeId, libraryId, state) => {
    const currentLibrary = showLibrary.filter((elm) => {
      return elm.libraryId === libraryId;
    });
    showTypeElement.map((elm) => {
      if (elm.libraryId === libraryId && typeId === elm.id) {
        elm.state = state;
      }
    });
    dispatch(showMarkerseByTypeElement(showTypeElement));
    const currentObjectsType = showTypeElement.filter((elm) => {
      return elm.libraryId === libraryId;
    });

    const currentObjectsActivate = currentObjectsType.filter((elm) => {
      return elm.state === true;
    });

    if (showDataObjects.state === false) {
      dispatch(
        setShowDataObjects({ state: state, color: `${SET_VISIBILITY_ICON}` })
      );
    }
    if (currentObjectsActivate.length === 0) {
      const dataLibraryObject = showLibrary.map((elm) => {
        if (elm.libraryId === libraryId) {
          return { ...elm, state: false, color: `${VISIBILITY_OFF_ICON}` };
        } else {
          return elm;
        }
      });

      if (getLibrariesTrue(showLibrary)) {
        dispatch(
          setShowDataObjects({
            state: true,
            color: `${SET_VISIBILITY_ICON}`,
          })
        );
      }
      dispatch(showMarkerseByTypeObject(dataLibraryObject));
      if (getLibrariesTrue(showLibrary) === false) {
        dispatch(
          setShowDataObjects({
            state: false,
            color: `${VISIBILITY_OFF_ICON}`,
          })
        );
      }
    }
    if (currentObjectsActivate.length > 0) {
      const dataLibraryObject = showLibrary.map((elm) => {
        if (elm.libraryId === libraryId) {
          return { ...elm, state: true, color: `${SET_VISIBILITY_ICON}` };
        } else {
          return elm;
        }
      });
      dispatch(showMarkerseByTypeObject(dataLibraryObject));
      dispatch(
        setShowDataObjects({ state: true, color: `${SET_VISIBILITY_ICON}` })
      );
      if (
        getLibrariesTrue(showLibrary) === false &&
        currentLibrary.length === 1
      ) {
        dispatch(
          setShowDataObjects({ state: true, color: `${PRIMARY_COLOR}` })
        );
      }
    }
    if (currentObjectsActivate.length === currentLibrary.length) {
      const dataLibraryObject = showLibrary.map((elm) => {
        if (elm.libraryId === libraryId) {
          return { ...elm, state: true, color: `${PRIMARY_COLOR}` };
        } else {
          return elm;
        }
      });
      dispatch(showMarkerseByTypeObject(dataLibraryObject));
    }
    if (
      currentObjectsActivate.length === currentLibrary.length &&
      getLibrariesTrue(showLibrary)
    ) {
      dispatch(setShowDataObjects({ state: true, color: `${PRIMARY_COLOR}` }));
    }
    dispatch(setFilterObject(true));
  };

  const currentLibrarys = deleteDuplicatePointsLibrary(
    showLibrary.length > 0 ? showLibrary : []
  );

  const showTypeElementSort = showTypeElement.sort((a, b) =>
    a.name.localeCompare(b.name)
  );
  const currentLibrarysSort = currentLibrarys.sort((a, b) =>
    a.name.localeCompare(b.name)
  );

  return (
    <Accordion
      sx={{
        paddingLeft: "0px",
        border: "none",
        boxShadow: "none",
      }}
      defaultExpanded={false}
    >
      <WrapperTypeObjectTitle>
        <div className="icon-title">
          {showDataObjects.state ? (
            <VisibilityIcon
              sx={{
                color: showDataObjects.color,
                margin: "10px 10px 10px 15px",
                cursor: "pointer",
              }}
              onClick={() =>
                handlerClickFilterObjects(false, `${VISIBILITY_OFF_ICON}`)
              }
            />
          ) : (
            <VisibilityOffIcon
              sx={{
                color: `${VISIBILITY_OFF_ICON}`,
                margin: "10px 15px",
                cursor: "pointer",
              }}
              onClick={() =>
                handlerClickFilterObjects(true, `${PRIMARY_COLOR}`)
              }
            />
          )}
          <p>Objects</p>
        </div>
        <AccordionSummary expandIcon={<ExpandMoreIcon />}></AccordionSummary>
      </WrapperTypeObjectTitle>
      {currentLibrarys.length !== 0 &&
        currentLibrarysSort.map((elm) => {
          return (
            <AccordionDetails
              sx={{
                padding: "1px 1px 1px",
                marginLeft: "10px",
              }}
            >
              <Accordion
                sx={{
                  paddingLeft: "5px",
                  border: "none",
                  boxShadow: "none",
                }}
                defaultExpanded={false}
              >
                <WrapperTypeObjectTitle>
                  <div className="icon-title">
                    {elm.state ? (
                      <VisibilityIcon
                        sx={{
                          color: elm.color,
                          margin: "10px 10px 10px 15px",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          handlerClickFilterComponentsByLibrary(
                            false,
                            elm.libraryId,
                            `${VISIBILITY_OFF_ICON}`
                          )
                        }
                      />
                    ) : (
                      <VisibilityOffIcon
                        sx={{
                          color: elm.color,
                          margin: "10px 15px",
                          cursor: "pointer",
                        }}
                        onClick={() =>
                          handlerClickFilterComponentsByLibrary(
                            true,
                            elm.libraryId,
                            `${PRIMARY_COLOR}`
                          )
                        }
                      />
                    )}
                    <p>{elm.name}</p>
                  </div>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon />}
                  ></AccordionSummary>
                </WrapperTypeObjectTitle>
                <AccordionDetails>
                  {showTypeElementSort.map((elm2) => {
                    return (
                      <WrapperTypeObjectTitle>
                        {elm.libraryId === elm2.libraryId ? (
                          <>
                            <div className="icon-title">
                              {elm2.state ? (
                                <VisibilityIcon
                                  sx={{
                                    color: `${PRIMARY_COLOR}`,
                                    margin: "10px 10px 10px 15px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handlerClickFilterComponentsByType(
                                      elm2.id,
                                      elm2.libraryId,
                                      false,
                                      `${VISIBILITY_OFF_ICON}`
                                    )
                                  }
                                />
                              ) : (
                                <VisibilityOffIcon
                                  sx={{
                                    color: `${VISIBILITY_OFF_ICON}`,
                                    margin: "10px 15px",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    handlerClickFilterComponentsByType(
                                      elm2.id,
                                      elm2.libraryId,
                                      true,
                                      `${PRIMARY_COLOR}`
                                    )
                                  }
                                />
                              )}
                              <p>{elm2.name}</p>
                            </div>
                            <div>
                              <img
                                src={elm2.icon}
                                width="30px"
                                height="30px"
                                alt="ico"
                              />
                            </div>
                          </>
                        ) : (
                          <></>
                        )}
                      </WrapperTypeObjectTitle>
                    );
                  })}
                </AccordionDetails>
              </Accordion>
            </AccordionDetails>
          );
        })}
    </Accordion>
  );
};

export default FilterObjects;
